import { render, staticRenderFns } from "./modal-guidelines.vue?vue&type=template&id=9463276c"
import script from "./modal-guidelines.vue?vue&type=script&lang=js"
export * from "./modal-guidelines.vue?vue&type=script&lang=js"
import style0 from "./modal-guidelines.vue?vue&type=style&index=0&id=9463276c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports